import { EXAMPLE_IDS } from './example-ids.js';
/** A 1×1 PNG, as a multipart example's file. */
export const EXAMPLE_PNG = {
    name: 'old-quay-engraving.png',
    type: 'image/png',
    base64: 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==',
};
/** The stored image `assets.upload` and `assets.fetch` answer with. */
export const EXAMPLE_ASSET = {
    assetId: EXAMPLE_IDS.assetQuayEngraving.id,
    sha256: '497790947d4666760ce38f3c00e852c71fdb66cae849bae8e9ede352719e1581',
    mime: 'image/png',
    bytes: 70,
    width: 1,
    height: 1,
    url: `/files/${EXAMPLE_IDS.assetQuayEngraving.id}`,
};
/** The remote image `assets.fetch`'s example re-hosts (a reserved example domain). */
export const EXAMPLE_REMOTE_IMAGE_URL = 'https://images.example.org/drowned-lanterns/old-quay-engraving.png';
//# sourceMappingURL=examples-assets.js.map